module.exports = __webpack_public_path__ + "static/media/company-six.6d86a7dc.jpg";